import { useRef } from 'react';
import type { Board } from '../hooks/useGameBoard';

interface NumpadProps {
  board: Board;
  highlightDigit: number | null;
  onNumberClick: (n: number) => void;
  disabled?: boolean;
  className?: string;
}

export function Numpad({ board, highlightDigit, onNumberClick, disabled, className }: NumpadProps) {
  const digitCounts = Array.from({ length: 10 }, () => 0);
  for (let r = 0; r < 9; r++)
    for (let c = 0; c < 9; c++)
      if (board[r]?.[c]) digitCounts[board[r][c]!]++;

  // Touch + click cift tetiklemeyi onlemek icin son tetiklenme zamanini tut
  const lastFireRef = useRef<{ n: number; t: number }>({ n: 0, t: 0 });

  const fire = (n: number) => {
    const now = Date.now();
    if (lastFireRef.current.n === n && now - lastFireRef.current.t < 300) return;
    lastFireRef.current = { n, t: now };
    onNumberClick(n);
  };

  return (
    <div className={className}>
      <div className="number-pad">
        {[1,2,3,4,5,6,7,8,9].map(n => {
          const btnDisabled = disabled || digitCounts[n] >= 9;
          return (
            <button
              key={n}
              type="button"
              className={`num-btn ${digitCounts[n] >= 9 ? 'completed' : ''} ${highlightDigit === n ? 'active' : ''}`}
              onPointerUp={(e) => {
                if (btnDisabled) return;
                if (e.pointerType === 'touch' || e.pointerType === 'pen') {
                  e.preventDefault();
                  fire(n);
                }
              }}
              onClick={() => { if (!btnDisabled) fire(n); }}
              disabled={btnDisabled}
            >
              {n}
              <span className="num-count">{9 - digitCounts[n]}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
